import vormatsLogo from '../../../assets/vormatsLogo.png';

export const getAvatarFromMessage = message => {
  const { metadata, sender, thumbnail } = message;

  if (metadata?.avatar) {
    return metadata.avatar;
  }

  if (thumbnail !== null) {
    return thumbnail;
  }

  if (!sender || sender?.toLowerCase()?.includes('vormats') || sender === '') {
    return vormatsLogo;
  }

  return null;
};

export const getMessageTitle = message => {
  if (message.subject === null) {
    return message.sender;
  } else {
    return message.subject;
  }
};
